import { textReaderPath } from "./textRoutes";

const CURRENT_TEXT_KEY = "trufapp.currentWritingText";

export function rememberWritingText(text) {
  if (!text?.id && !text?.textId) return;
  const id = text.id || text.textId;
  const snapshot = {
    id,
    textId: id,
    title: text.title || "Sin titulo",
    slug: text.slug || "",
    dateSlug: text.dateSlug || "",
    deskSlug: text.deskSlug || "",
    drawerSlug: text.drawerSlug || "",
    notebookSlug: text.notebookSlug || "",
    deskId: text.deskId || "",
    drawerId: text.drawerId || "",
    notebookId: text.notebookId || "",
    updatedAt: text.updatedAt || Date.now(),
    rememberedAt: Date.now(),
  };

  try {
    sessionStorage.setItem(CURRENT_TEXT_KEY, JSON.stringify(snapshot));
    window.dispatchEvent(new CustomEvent("trufapp:writing-text", { detail: snapshot }));
  } catch (_e) {}
}

export function getRememberedWritingText() {
  try {
    const raw = sessionStorage.getItem(CURRENT_TEXT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
}

export function rememberedTextPath(text = getRememberedWritingText()) {
  if (!text) return "";
  return textReaderPath(text);
}
